<template>
  <div>

<!--    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">首页</div>-->

    <div style="background-color: #eee;overflow-y: scroll;" :style="th">

      <div style="padding: 10px">

        <div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">科室总数</div>
              <div style="">{{this.elderlyCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">岗位总数</div>
              <div style="">{{this.elderlyCountMan}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">职工总数</div>
              <div style="">{{this.businessCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">绩效占总收入</div>
              <div style="">{{this.serveCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">绩效占医疗收入</div>
              <div style="">{{this.deviceCount}}</div>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">当月收入金额</div>
              <div style="">{{this.alarmRecordCount}}</div>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">当月绩效金额</div>
              <div style="">{{this.alarmRecordCountWait}}</div>
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">日收入支出</div>
                <ve-line :data="chartData_total_day" :settings="chartSettings_total_day"></ve-line>
              </div>

            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">月收入支出</div>
                <ve-histogram :data="chartData_total_month" :settings="chartSettings_total_month"></ve-histogram>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">科室人均绩效</div>
                <ve-bar :data="chartData_elderly" :settings="chartSettings_elderly"></ve-bar>
              </div>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">收入占比</div>
                <ve-pie :data="chartData_goods" :settings="chartSettings_goods"></ve-pie>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>




      </div>

    </div>


  </div>

</template>



<script>


import {timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode, removeToken} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Home",

  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        console.log("JobClass 需要重加载");
        //this.init();
      }
    }
    else{
      console.log("JobClass 需要重加载");
      //this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },


  components:{

  },
  data: function () {
    return {

      th:'',


      chartSettings_total_day:{
        labelMap:{
          day:"日期",
          count:"收入金额",
          money:"支出金额",
        }
      },
      chartData_total_day: {
        columns: ['day', 'count','money'],
        rows: [
          {'day':'1','count':'20','money':'200'},
        ]
      },




      chartSettings_total_month:{
        labelMap:{
          month:"月份",
          count:"收入金额",
          money:"支出金额",
        }
      },
      chartData_total_month: {
        columns: ['month', 'count','money'],
        rows: [
          {'month':'1','count':'203','money':'2000'},
        ]
      },




      chartSettings_elderly:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          age:"年龄",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          man:"人均绩效",
          //woman:'女',
        }
      },
      chartData_elderly: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['age', 'man'],
        rows: [
          {'age':'眼科','man':'20','woman':'22'},
          {'age':'牙科','man':'14','woman':'17'},
          {'age':'外科','man':'10','woman':'12'},
          {'age':'内科','man':'8','woman':'7'},
          {'age':'急诊科','man':'7','woman':'4'},
        ]
      },

      chartSettings_goods:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"收入项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_goods: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'床位','total':'203'},
          {'class':'护理','total':'143'},
          {'class':'化验','total':'93'},
          {'class':'检查','total':'60'},
          {'class':'手术','total':'35'},
          {'class':'材料','total':'22'},
        ]
      },



      elderlyCount:0,
      elderlyCountMan:0,
      elderlyCountWoman:0,

      businessCount:0,
      serveCount:0,
      deviceCount:0,

      alarmRecordCount:0,
      alarmRecordCountWait:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+140-25)+"px";
    },
  },
  created(){
    this.th = "height:"+(this.$store.state.tableHeight+140-25)+"px";

  },
  methods:{



    loginOut(){

      removeToken();

      window.localStorage.setItem('activeInstitutionCode', null);
      window.localStorage.setItem('activeStaffCode', null);
      window.localStorage.setItem('activeMenuTop', null);
      window.localStorage.setItem('listMenuDTO', null);
      window.localStorage.setItem('listMenuTop', null);
      window.localStorage.setItem('listMenuLeft', null);
      window.localStorage.setItem('isHome', null);

      this.$store.commit('update', ['loginToken',null]);


      this.$router.push({ path: '/login' })

    },

    getElderlyCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.elderlyCount = response.data.data.elderlyCount;
              this.elderlyCountMan = response.data.data.elderlyCountMan;
              this.elderlyCountWoman = response.data.data.elderlyCountWoman;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getBusinessCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
            if (response.data.error == 0) {
              this.businessCount = response.data.data.businessCount;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)

              if(response.data.message.indexOf("禁用")!=-1){
                this.loginOut();
              }

            }
          })

    },


    getServeCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.serveCount = response.data.data.serveCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getDeviceCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"UserDevice/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.deviceCount = response.data.data.deviceCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getAlarmRecordCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.alarmRecordCount = response.data.data.alarmCount;
              this.alarmRecordCountWait = response.data.data.alarmCountWait;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getTotalOrder(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
            if (response.data.error == 0) {

              let listTotalOrderDay = response.data.data.listTotalOrderDay;
              let arr = [];
              for(let i=0;i<listTotalOrderDay.length;i++){
                arr.push({"day":listTotalOrderDay[i].day,"count":listTotalOrderDay[i].orderCount,"money":listTotalOrderDay[i].orderMoney});
              }
              this.chartData_total_day.rows = arr;

              let listTotalOrderMonth = response.data.data.listTotalOrderMonth;
              let arr2 = [];
              for(let i=0;i<listTotalOrderMonth.length;i++){
                arr2.push({"month":listTotalOrderMonth[i].month,"count":listTotalOrderMonth[i].orderCount,"money":listTotalOrderMonth[i].orderMoney});
              }
              this.chartData_total_month.rows = arr2;

              let listTotalGoodsClassGovernment = response.data.data.listTotalGoodsClassGovernment;
              let arr3 = [];
              for(let i=0;i<listTotalGoodsClassGovernment.length;i++){
                arr3.push({"class":listTotalGoodsClassGovernment[i].goodsClassName,"total":listTotalGoodsClassGovernment[i].orderCount+''});
              }
              this.chartData_goods.rows = arr3;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })

    },


    getAge(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/PannelAgeCount",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {


          this.chartData_elderly.rows = response.data.data.jsonArray;


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }

}


</script>

